import { render, staticRenderFns } from "./ehc-qrcode.vue?vue&type=template&id=676714f5"
import script from "./ehc-qrcode.vue?vue&type=script&lang=js"
export * from "./ehc-qrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports